import ClipLoader from "react-spinners/ClipLoader";

export default function LayoutLoading({ loading, children }) {
    if (loading) return (
        <div className="layout-loading">
            <ClipLoader
                color={'black'}
                loading={loading}
                override={{
                    borderWidth: '10px'
                }}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )

    return children;
} 